import {
  viandas2Get,
  viandas2Post,
  viandas2Put,
  viandas2Patch,
} from "../../../common/service/viandas2Client";

export const getProveedores = () => viandas2Get("/rrhh/proveedores");

export const getProveedor = (id) => viandas2Get(`/rrhh/proveedores/${id}`);

export const crearProveedor = (nombre) =>
  viandas2Post("/rrhh/proveedores", { nombre });

export const actualizarProveedor = (id, nombre) =>
  viandas2Put(`/rrhh/proveedores/${id}`, { nombre });

export const cambiarEstadoProveedor = (id, activo) =>
  viandas2Patch(`/rrhh/proveedores/${id}/estado`, { activo });

export const getProveedoresPorSucursal = (idSucursal) =>
  viandas2Get(`/rrhh/proveedores/sucursal/${idSucursal}`);

export const asociarProveedorASucursal = (idSucursal, idProveedor) =>
  viandas2Post("/rrhh/proveedores/sucursal", {
    id_sucursal: idSucursal,
    id_proveedor: idProveedor,
  });

export const cambiarEstadoAsociacion = (idAsociacion, activo) =>
  viandas2Patch(`/rrhh/proveedores/sucursal/${idAsociacion}/estado`, { activo });
